import script from "./animatedGiftOne.vue?vue&type=script&setup=true&lang=ts"
export * from "./animatedGiftOne.vue?vue&type=script&setup=true&lang=ts"

import "./animatedGiftOne.vue?vue&type=style&index=0&id=bd82e0b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd82e0b6"]])

export default __exports__